<template>
  <div class="settlement-amount-page">
    <div class="inquire-module">
      <a-form-model ref="ruleForm" :model="formData" :rules="rules">
        <a-row :gutter="24">
          <a-col :md="3" :sm="6">
            <a-form-model-item label="往来单位" prop="danwei">
              <a-input placeholder="请输入菜单路径" v-model="formData.danwei" class="border-radius-input">
                <a-tooltip slot="suffix" title="更多">
                  <img src="@/assets/image/gengduo.png" alt="" style="width: 12px;">
                </a-tooltip>
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :md="3" :sm="6">
            <a-form-model-item label="经办人">
              <a-input placeholder="请输入经办人" v-model="formData.jingbanren" class="border-radius-input">
                <a-tooltip slot="suffix" title="更多">
                  <img src="@/assets/image/gengduo.png" alt="" style="width: 12px;">
                </a-tooltip>
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :md="4" :sm="6">
            <a-form-model-item label="摘要">
              <a-input placeholder="摘要信息" class="border-radius-input" v-model="formData.zhaiyao" />
            </a-form-model-item>
          </a-col>
          <a-col :md="4" :sm="6">
            <a-form-model-item label="备注">
              <a-input placeholder="请输入备注" class="border-radius-input" v-model="formData.beizhu" />
            </a-form-model-item>
          </a-col>
          <a-col :md="4" :sm="6">
            <a-popover v-model="visible" trigger="click" placement="bottomLeft">
              <div slot="content" class="a-popover-add-make">
                <a-row>
                  <a-col style="width:216px">
                    <span class="label-title">开票类型</span>
                    <a-select labelInValue style="width: 140px;" placeholder="选择开票类型" @change="changeMakeInvoice">
                      <a-icon slot="suffixIcon" type="caret-down" style="color: #555555" />
                      <a-select-option value="jack" v-for="(item, index) in invoiceList" :key="index"></a-select-option>
                    </a-select>
                  </a-col>
                  <a-col>
                    <a-input placeholder="税率" v-model="formData.shuilv" />%
                  </a-col>
                </a-row>
                <a-row style="margin-top:30px">
                  <a-col style="width:216px">
                    <span class="label-title">附件文件</span>
                    <a-button icon="upload" class="upload-button">
                      上传附件
                    </a-button>
                  </a-col>
                  <a-col>
                    <span style="color: #F76F14;margin-left:24px">现有4</span>
                  </a-col>
                </a-row>
                <a-row class="upload-list">
                  <a-col v-for="(item,index) in 3" :key="index">
                    <div class="icon-name">
                      <a-icon type="link" />
                      <span>这是一个附件.jpg</span>
                    </div>
                    <a-icon type="delete" />
                  </a-col>
                </a-row>
              </div>
              <a-button class="border-color">更多
                <a-icon type="right-circle" />
              </a-button>
            </a-popover>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
    <!-- 付款账户 -->
    <div class="choose-products-table" :style="{height: accountHeight+'px'}">
      <a-table :columns="accountList" :dataSource="accountData" :pagination="false" rowKey="id" bordered :scroll="{ y: accountHeight-50 }">
        <template slot="zhanghu" slot-scope="text, record">
          <a-input placeholder="请选择账户 " v-if="isEmpty(text)" @click="btnInput(record)">
            <a-tooltip slot="suffix" title="更多">
              <img src="@/assets/image/gengduo.png" alt="" style="width: 12px;">
            </a-tooltip>
          </a-input>
          <span v-else>{{ text }}</span>
        </template>
        <template slot="operation" slot-scope="text">
          <img src="@/assets/image/gengduo.png" alt="" style="width: 12px;">
        </template>
      </a-table>
    </div>

    <div class="settlement-amount-logistics-price">
      <div class="settlement-amount-price">
        <a-row class="ant-row-align-items">
          <a-col>
            <span class="price-title">合计：</span>
            <span class="price-color">¥ 5000.00</span>
          </a-col>
          <a-col style="margin-left: 26px">
            <span class="price-title">优惠金额：</span>
            <a-input placeholder="请输入金额" v-model="formData.youhui" style="width: 100px">
            </a-input>
          </a-col>
        </a-row>
        <a-row>
          <a-col>
            <span class="price-title-bold">此前应收：</span>
            <span class="price-color">¥ 1000.00</span>
          </a-col>
          <a-col>
            <span class="price-title-bold">本次应收：</span>
            <span class="price-color">¥ <span style="font-size: 40px; ">5000.00</span></span>
          </a-col>
          <a-col>
            <span class="price-title-bold">合计应收：</span>
            <span class="price-color">¥ 6000.00</span>
          </a-col>
        </a-row>
      </div>
    </div>
    <public-footer :buttonList="buttonList" @onClickButton="onClickButton"></public-footer>
    <preserve-modal ref="preserve"></preserve-modal>
  </div>
</template>
<script>
import pick from 'lodash.pick'
import publicFooter from '@/components/module/publicFooter.vue'
import preserveModal from '@/components/module/preserveModal.vue'
export default {
  name: 'makeOffers',
  components: {
    publicFooter,
    preserveModal
  },
  data () {
    return {
      visible: false,
      rules: {
        danwei: [{ required: true, message: '请输入往来单位', trigger: 'blur' }],
      },      // 毕传设置
      formData: {
        youhui: '',
        danwei: '',
        jingbanren: '',
        zhaiyao: '',
        beizhu: '',
        shuilv:'',
      },         // 表单数据

      accountList: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 80,
          align: "center",
          customRender: function (t, r, index) {
            if (t.name != 'footer') {
              return parseInt(index) + 1
            } else {
              return ''
            }
          }
        }, {
          title: '付款账户',
          dataIndex: 'zhanghu',
          scopedSlots: { customRender: 'zhanghu' },
        }, {
          title: '付款金融',
          dataIndex: 'jinrong',
        }, {
          title: '备注',
          dataIndex: 'beizhu',
        }, {
          title: '操作',
          width: 100,
          align: 'center',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
        }
      ],            // 账户表格头部
      accountData: [
        {
          zhanghu: '支付宝18************',
          jinrong: '¥6000.00',
          beizhu: '余款由中国银行结清',
        }, {
          zhanghu: '支付宝18************',
          jinrong: '¥6000.00',
          beizhu: '余款由中国银行结清',
        }, {}
      ],          // 账户数据
    
      invoiceList: [],    // 开票类型
      accountHeight:0,   // 账户表格高度

      buttonList:[
          {
              id:1,
              text:'取消退出'
          },{
              id:2,
              text:'付款单记录'
          },{
              id:3,
              text:'存为待过账'
          },{
              id:4,
              text:'提交过账'
          }
      ],         // 底部按钮
    }
  },
  mounted () {
    this.accountHeight = document.body.offsetHeight-560
  },
  methods: {
    // 选择开票类型
    changeMakeInvoice () {

    },
    btnInput (item) {
      console.log(item)
    },
    // 点击底部按钮
    onClickButton (item) {
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            alert('submit!');
          } else {
            return false;
          }
        });
    //   this.$refs.preserve.show()
    },
    resetForm () {
      this.$refs.ruleForm.resetFields();
    },
  }
}
</script>

<style lang="scss">
.settlement-amount-page {
  .inquire-module {
    padding: 30px 30px 0 30px;
    background-color: #ffffff;
    .ant-row {
      .ant-form-item {
        display: flex;
      }
      .ant-form-item-control-wrapper {
        flex: 1;
      }
    }
    .border-color {
      width: 80px !important;
      height: 32px !important;
      border-radius: 6px;
      margin: 3px 0;
      color: #f76f14;
      font-size: 14px;
      line-height: 32px !important;
    }
    .ant-form-item-children {
      width: 100%;
      .ant-calendar-picker {
        width: 100%;
      }
      .ant-calendar-picker-input {
        width: 100% !important;
      }
    }
  }
  .choose-products-table {
    margin-top: 16px;
    .ant-table-wrapper {
      padding: 0;
    }
    .ant-table-thead {
      tr {
        th {
          height: 50px;
          padding: 0 16px !important;
        }
      }
    }
    .ant-table-tbody {
      tr:last-child {
        height: 50px;
        td {
          border-right: 0 !important;
          padding: 10px 0 !important;
          .ant-input {
            border-radius: 0 !important;
          }
        }
      }
    }
  }
  .settlement-amount-logistics-price {
    display: flex;
    justify-content: flex-end;
    background-color: #ffffff;
    padding: 0 34px;
    margin-top: 16px;
    .settlement-amount-price {
      padding: 16px 0;
      .ant-row {
        display: flex;
        align-items: flex-end;
        justify-content: flex-end;
        line-height: 1;
        .ant-col {
          margin-left: 42px;
        }
        .price-color {
          font-size: 16px;
          color: #f76f14;
          font-weight: bold;
        }
        .price-title-bold {
          font-weight: bold;
        }
      }
      .ant-row-align-items {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 16px 0;
      }
    }
  }
}
.a-popover-add-make {
  width: 340px;
  padding: 10px 10px 20px 10px;
  .ant-row {
    display: flex;
    .ant-col {
      height: 36px;
      display: flex;
      align-items: center;
      .label-title {
        display: inline-block;
        width: 72px;
        font-size: 14px;
        color: #333333;
        padding-right: 15px;
      }
      .ant-select-selection {
        height: 36px !important;
      }
      .ant-select-selection__rendered {
        line-height: 36px !important;
      }
      .ant-input {
        width: 52px !important;
        height: 32px !important;
        line-height: 32px !important;
        border-radius: 2px !important;
        margin: 0 8px 0 24px;
      }
    }
  }
  .upload-list {
    margin-top: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 72px;
    .ant-col {
      height: 18px;
      margin: 6px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .icon-name {
        color: #387bfc;
        .anticon-link {
          margin-right: 12px;
        }
      }
      .anticon-link,
      .anticon-delete {
        font-size: 18px;
      }
    }
  }
}
</style>